import { Button, Typography } from "@/common/styles/style";

interface CSVDownloadButtonProps {
  handleClick: () => void;
}
export default function CSVDownloadButton({
  handleClick,
}: CSVDownloadButtonProps) {
  return (
    <Button variant="contained" size="small" onClick={handleClick}>
      <Typography variant="button">CSVダウンロード</Typography>
    </Button>
  );
}
